import React from 'react'
import {connect} from 'react-redux'
import DataLoader from '../data/DataLoader'
import Gallery from '../gallery/Gallery'
import VimeoPlayer from '../misc/VimeoPlayer'
import Footer from '../footer/Footer'
import { withRouter, Link } from 'react-router-dom'
import MetaTags from 'react-meta-tags'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Error404 from './Error404'


class FilmDetailPage extends React.Component {



  constructor(props){
    super();
    this.state = {
      currentFilm : false,
      prevFilm:false,
      nextFilm:false,
      videoFile : false
    }

    //console.log("constructor",props);

  }


  findCurrentFilm(props){

      let urlParam = props.match.params.currentfilm
      let currentFilmIndex
      let currentFilm = props.filmData.data.filter((item,index)=>{
          if(item.slug===urlParam){
            currentFilmIndex = index;

          }
            return (item.slug===urlParam)
      })[0]

      console.log('currentFilm',currentFilm);

      let nextFilm = props.filmData.data[currentFilmIndex+1]
      let prevFilm = props.filmData.data[currentFilmIndex-1]

      this.setState({currentFilm,nextFilm,prevFilm})


      //this.getTheVideoFile();
  }

  getTheVideoFile(){

      fetch('http://vimeotest:8888/')
            .then((data) =>{
              console.log(data);
            })

      let url ='http://vimeotest:8888/';
            fetch(url)
              .then(results => results.json())
              .then(array => {
                //this.filmDataLoaded(array)
                //console.log(array);

                let videoFile = array.body.files[3].link
                console.log("videoFile:",videoFile);
                this.setState({videoFile})
              })

  }

  componentWillUpdate(){


  }

  componentWillReceiveProps(newProps){

    //console.log('This Props',newProps);

    this.findCurrentFilm(newProps)


    if(newProps.location.pathname !== this.props.location.pathname){
      console.log("Srcoll up");
      (this.refs.content)?
        this.refs.content.scrollTop = 0
      : null ;


      this.refs.content.classList.add('animation-restart')
      setTimeout(()=>{
          this.refs.content.classList.remove('animation-restart')
      },5)
    }


  }

  componentWillMount(){
      //console.log("Component Will Mount",this.props);
      (this.props.filmData!==undefined)?
        this.findCurrentFilm(this.props)
      : null ;

  }

  createMarkup(str) {
  return {__html: str};
  }



  render () {

      let currentFilm = this.state.currentFilm


      //console.log(currentFilm);

      return(
          <DataLoader load='films' loadAll='true'>

              <div className="page-wrapper film-details-page" ref="content">

              {(currentFilm)?

              <div>

                <MetaTags>
                  <meta id="meta-description" name="description" content={currentFilm.acf.meta_description} />
                  <title>{'The Fyzz - Facility | '+currentFilm.title.rendered}</title>
                  <meta id="og-title" property="og:title" content={'The Fyzz - Facility | '+currentFilm.title.rendered} />
                  <meta id="og-image" property="og:image" content={currentFilm.acf.poster_image.url} />
                </MetaTags>

                <div className="hero-image" style={{backgroundImage: 'url('+currentFilm.acf.poster_image.url+')'}}>
                  {(currentFilm.acf.film_trailer_promo)?
                    <VimeoPlayer video={currentFilm.acf.film_trailer_promo} />
                    : null
                  }
                </div>

                <div className="film-details">

                  <div className="film-text-coloumn">
                    <div className="title"><h1 dangerouslySetInnerHTML={this.createMarkup(currentFilm.title.rendered)}></h1><div className="light-header">{currentFilm.acf.release_year}</div></div>
                    {

                      currentFilm.acf.content.map((item,index)=>{


                          let content

                          switch (item.acf_fc_layout) {
                            case 'text_box':
                                content =  <div className="text-box" dangerouslySetInnerHTML={this.createMarkup(item.text_content)}></div>
                                break;

                              case 'photo':
                                content = <div className="photo"><img src={item.image.url} /><div className="photo-caption">{item.caption}</div></div>
                                break;

                              case 'quote':
                                content = <div className="qoute"><blockqoute dangerouslySetInnerHTML={this.createMarkup(item.quote)}></blockqoute><div className="authour">{item.authour}</div></div>
                                break;
                            default:
                              null
                      }

                        return <div className="row" key={'row'+index}>{content}</div>


                      })
                    }

                  </div>



                <div className="film-credits">

                    <div className="share">
                        <div className="icon"></div>
                        <span className="share-label">Share this page</span>

                          <div className="links">
                              <a className="facebook" href={"https://www.facebook.com/sharer/sharer.php?u="+window.location.href} target="_blank">Share on facebook</a>
                              <a className="twitter" href={"https://twitter.com/home?status="+escape('The Fyzz | '+currentFilm.title.rendered+'   '+window.location.href)} target="_blank">Share on Twitter</a>
                          </div>
                    </div>
                    <div className="credit-list">

                    {(currentFilm.acf.featuring)?
                      <div>
                        <h5>Featuring:</h5>
                        <div dangerouslySetInnerHTML={this.createMarkup(currentFilm.acf.featuring)}></div>
                        </div>
                    : null }

                    {(currentFilm.acf.director)?
                        <div>
                          <h5>Director:</h5>
                          <div dangerouslySetInnerHTML={this.createMarkup(currentFilm.acf.director)}></div>
                        </div>
                    : null }
                    {(currentFilm.acf.screenplay)?
                      <div>
                        <h5>Screenplay:</h5>
                        <div dangerouslySetInnerHTML={this.createMarkup(currentFilm.acf.screenplay)}></div>
                      </div>
                    : null }
                      {(currentFilm.acf.status)?
                        <div>
                          <h5>Status:</h5>
                          <div dangerouslySetInnerHTML={this.createMarkup(currentFilm.acf.status)}></div>
                        </div>
                      : null }


                    {(currentFilm.acf.role)?
                      <div>
                        <h5>Role:</h5>
                        <div dangerouslySetInnerHTML={this.createMarkup(currentFilm.acf.role)}></div>
                      </div>
                      : null}


                    {(currentFilm.acf.links)?
                      <div>
                      <h5>Links:</h5>
                      <div>
                          {currentFilm.acf.links.map((item,index) =>{

                                return <a style={{display:'block'}} key={'link'+index} href={item.url} target={item.newWindow? '_blank' : '_self'}>{item.label}</a>

                            })
                            }

                      </div>
                      </div>
                     : null }


                  </div>
                  {
                    (currentFilm.acf.gallery_images.length)?
                      <div>
                        <h5>Posters:</h5>
                        <Gallery items={currentFilm.acf.gallery_images} ></Gallery>
                      </div>
                    : null
                  }

                </div>

              </div>
              <div className="horizontal-divder"></div>
              <div className="bottom-project-nav content-row">
                {
                  (this.state.prevFilm)?
                    <Link to={this.state.prevFilm.slug} className="prev">
                      <h5>Previous project</h5>
                      <span dangerouslySetInnerHTML={{__html:this.state.prevFilm.title.rendered}}></span>
                    </Link>
                   : <div className="prev">
                       <h5></h5>
                       <span></span>
                   </div>
                  }

                    <Link to="/projects/" className="all">
                      All Projects
                    </Link>
                    {
                      (this.state.nextFilm)?
                        <Link to={this.state.nextFilm.slug} className="next">
                          <div>
                            <h5>Next project</h5>
                            <span dangerouslySetInnerHTML={{__html:this.state.nextFilm.title.rendered}}></span>
                          </div>
                        </Link>
                        : <div className="next">
                            <h5></h5>
                            <span></span>
                        </div>
                    }
              </div>


              </div>

              :
                <div><Error404></Error404></div>


            }

          <Footer></Footer>
          </div>
          </DataLoader>
      )

  }
}

const mapStateToProps = (state) => {
    const filmData = state.filmData

    return{
      filmData
    }
}

export default withRouter(connect(mapStateToProps)(FilmDetailPage));



// WEBPACK FOOTER //
// ./src/modules/pages/FilmDetailPage.js